import Items from "@/widgets/Items.vue";
import FieldEditor from "@/components/FieldEditor.vue";
import FieldShow from "@/components/FieldShow.vue";
import EditorRelateid from "@/components/Fields/EditorRelateid.vue";
import OrderItems from "@/views/Order/subs/OrderItems.vue";

import { mapState, mapGetters, mapMutations } from "vuex";
import item from "@/datamodels/Item";

export default {
	components: {
		Items,
		OrderItems,
		FieldEditor,
		EditorRelateid,
		FieldShow,
	},
	data() {
		return {
			dataModelNames: ["Order", "Order_item"],
			loadings: {
				main: false,
				create: false,
				insert: false
			},
			rules: {
				customer: [
					{
						required: true,
						message: "请输入",
						trigger: "change",
						type: "object",
						fields: {
							name: { type: "string", required: true, message: "请选择" },
							_id: { type: "string", required: true, message: "请选择" }
						}
					}
				],
				pay_method: [
					{
						required: true,
						message: "请输入"
					}
				]
			},

			everEdited: false,
			priceRate:[],
			total_price_or:0,
			discount:0,
			vip_level:0
		};
	},
	computed: {
		...mapState(["dataModels", "loadingDM","currDbSource"]),
		itemsDuplicateCheck() {
			let checks = {};
			for (let i = 0; i < this.info.items.length; i++) {
				//特么0 也是 false 哦！！！！
				checks[this.info.items[i].item._id] = i + 1;
			}
			return checks;
		},
		total_price() {
			let total_price = 0;

			for (let k in this.info.items) {
				total_price += parseFloat(this.info.items[k].total_price);
			}
			this.total_price_or = total_price
			if(!this.info.express_fee){
				this.info.express_fee = 0
			}

			return parseFloat((total_price - this.info.discount + this.info.express_fee));
		},
		total_amount() {
			let total_amount = 0;
			for (let k in this.info.items) {
				total_amount += parseFloat(this.info.items[k].amount);
			}
			return total_amount;
		},
		hasGetTableDataModel() {
			return this.dataModelNames.every(val => {
				return this.dataModels[val] && this.dataModels[val]._id;
			});
		}
	},
	mounted() {
		this.refreshRoute();
		this.dataModelNames.forEach(val => {
			this.checkDataModel(val);
		});
		this.getPriceRate();
	},
	methods: {
		...mapMutations(["checkDataModel"]),
		getDiscount(){
			let vip_level = this.$store.state.currDbSource.index
			let rate = 1;
			let discount = 1;
			if (vip_level == 1 || vip_level == 5){
				rate = this.priceRate[vip_level]
			}
			console.log(this.total_price_or ,this.total_price_or,rate)
			discount = (this.total_price_or - this.total_price_or * rate).toFixed(2)
			this.info.discount = discount
		},
		getPriceRate(){
			this.$axios
				.post(`/curd/getPriceRate`)
				.then(json => {
					this.priceRate = json.data
				})
		},

		refreshRoute() {
			this.activeName = this.$route.params.tab;
		},
		doResetInsert() {
			this.doResetItems();
		},

		handlerPost() {
			if (this.info.items.length <= 0) {
				this.$message.error("尚未录入货单");
				return;
			}
			this.$refs["form"].validate(valid => {
				if (!valid) {
					this.$message.error("请检查输入");
					return false;
				}
				this._doPost();
			});
		},
		handleRemove(index) {
			this.info.items.splice(index, 1);
		},
		onInsertItems(items) {
			this.loadings.main = true;
			for (let k in items) {
				if (this.itemsDuplicateCheck[items[k].item._id]) {
					this.$message.error("录入数据有重复，请检查！");
					continue;
				}
				this.info.items.push(items[k]);
			}
			this.loadings.main = false;
		},
		initInfo(data) {
			this.fields.forEach(field => {
				if (field.name == "null") {
					return;
				}
				let initV;
				if (data) {
					initV = data[field.name];
				} else if (this.defaultValue && this.defaultValue[field.name]) {
					initV = this.defaultValue[field.name];
				} else {
					initV = this.dataModels.Order[field.name].default;
				}
				if (typeof initV == "undefined") {
					return;
				}
				this.$set(this.info, field.name, JSON.parse(JSON.stringify(initV)));
			});
		}
	},
	props:{
		agentLevel: {
			type: Object,
			default: () => {
				return {
					index: 0,
					name: "零售客户",
				};
			},
		},
	},
	watch: {
		"total_price_or":{
			handler(newval, oldval) {
				console.log(newval);
				console.log(oldval);
				console.log("total_price_or的值改变了");
				this.getDiscount()
			},
			immediate:true,
		},



		// 如果路由有变化，会再次执行该方法
		$route: "refreshRoute",
		hasGetTableDataModel: {
			handler(val) {
				if (val) {
					if (this.info.customer && this.info.customer._id == "") {
						this.initInfo();
					}
				}
			},
			immediate: true
		}
	}

};
